module.exports = "<p>The artist on<br><em>I&#39;m Not The Girl Who Misses Much</em> 1996</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio5/content.md
// module id = 839
// module chunks = 0